<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <div class="py-12 px-2 text-center">
          <img src="@/assets/images/svg/store_is_close.svg" alt="mail" class="img-store_is_close">
          <h4 class="headline" v-html="$t('store_closed_message')" />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
}
</script>
